import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=3c21b22c&scoped=true"
import script from "@/controllers/schedules.js?vue&type=script&lang=js&external"
export * from "@/controllers/schedules.js?vue&type=script&lang=js&external"
import style0 from "./Schedules.styles.css?vue&type=style&index=0&id=3c21b22c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21b22c",
  null
  
)

export default component.exports